<template>
  <v-card class="mt-4" flat>
    <v-card-text class="px-0">
      {{ $t("components.thg.thgQuickCheckout.thgDialogConfirm.description") }}
    </v-card-text>
    <v-chip v-for="(year, i) in selectedYears" :key="i" class="mx-2 pb-0 pt-0">{{ year }}</v-chip>
    <v-card-text class="px-0">
      <span>
        {{ $t("components.thg.thgQuickCheckout.thgDialogConfirm.footer") }}
      </span>
    </v-card-text>
    <v-card-text v-html="$t('components.thg.thgQuickCheckout.thgDialogConfirm.subtitle')" class="px-0"> </v-card-text>
    <v-form ref="form" v-model="formValid">
      <v-checkbox
        :rules="[requiredRule]"
        v-model="isConfirmed"
        ref="reviewed"
        :label="$t('report.thgClosing.confirmation')"
        class="px-0"
        data-test-review-checkbox
      ></v-checkbox>
      <v-checkbox
        :rules="[(v) => !!v || $t('report.thgClosing.readPrivacy')]"
        v-model="isTermsAccepted"
        :label="$t('report.thgClosing.confirmationPrivacy')"
        ref="privacy"
        class="px-0"
        data-test-privacy-checkbox
      >
      </v-checkbox>
    </v-form>
    <v-spacer></v-spacer>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ThgCreateModule } from "@/store/modules/thg.create.store";

@Component({
  filters: {
    commaSeparated(values: []): string {
      if (!values) return "";

      return values.join(", ");
    }
  }
})
export default class ThgQuickCheckoutClosingCard extends Vue {
  @Prop()
  thg!: ThgThgMeViewModelGen;

  @Prop()
  isValid!: boolean;

  get selectedYears() {
    return ThgCreateModule.years;
  }

  get formValid() {
    return this.isValid;
  }
  set formValid(v: boolean) {
    this.$emit("update:isValid", v);
  }

  get isConfirmed() {
    return ThgCreateModule.isConfirmed;
  }

  set isConfirmed(isConfirmed: boolean) {
    ThgCreateModule.setIsConfirmed(isConfirmed);
  }

  get isTermsAccepted() {
    return ThgCreateModule.isTermsAccepted;
  }

  set isTermsAccepted(isTermsAccepted: boolean) {
    ThgCreateModule.setIsTermsAccepted(isTermsAccepted);
  }

  get requiredRule() {
    return requiredRule();
  }
}
</script>
